export const discountCalculate = (total, discountType, discountValue) => {
  if (discountType == 'fixed') {
    return parseFloat(discountValue);
  }
  return parseFloat(parseFloat(total * (discountValue / 100)));
};
